// import OurServices from "./OurServices";
import DailyInfo from "./DailyInfo"; // Assuming DailyInfo is a component that displays daily information
import StarParticles from "./StarParticles";
import AstrologyClock from "./AstrologyClock";


function Home() {
  return (
    <div className="homepage homeLayout">
      <StarParticles />
      <div className="homeLayout__left">
        {/* <Carousel /> */}
        <AstrologyClock />
      </div>
      <div className="homeLayout__right">
        <DailyInfo />
      </div>
    </div>
  );
}


export default Home;
